define('LoginRegHTMLMessage.View',
    [
        'login_reg_html_message.tpl',
        'Backbone'
    ],
    function (
        login_reg_html_message_tpl,
        Backbone
    ) {
        'use strict';

        return Backbone.View.extend({

            template: login_reg_html_message_tpl,

            initialize: function (options) {
                this.loginRegHTMLMessage = options.loginRegHTMLMessage;
            },

            getContext: function getContext() {
                return {
                    htmlMessage: this.loginRegHTMLMessage
                }
            }
        });
    });
